<template>

  <div id="lesson-bonus" class="content">

    <mu-content-block v-if="isLoading" style="text-align: center">
      <mu-circular-progress :size="48"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>


    <div v-if="!isLoading">
      <mu-content-block style="padding-left: 0; padding-right: 0">
        <div class="title">
          <h1 v-text="data.title"></h1>
        </div>
        <div class="subTitle">
          {{data.summary}}
        </div>
      </mu-content-block>
      <iframe-video-player :src="data.video_player_url"></iframe-video-player>
      <questions-panel :courseId="data.course_id"></questions-panel>
    </div>

  </div>

</template>
<script>
  import LessonsApi from "../../api/Lessons"

  import TitleManager from "../../helpers/TitleManager"

  import IframeVideoPlayer from "../../components/IframeVideoPlayer/IframeVideoPlayer.vue";
  import QuestionsPanel from "../../components/Lesson/QuestionsPanel/QuestionsPanel.vue";

  export default {
    components: {
      QuestionsPanel,
      IframeVideoPlayer
    },
    data() {
      return {
        isLoading: true,
        data: {}
      }
    },
    mounted() {
      let self = this;
      LessonsApi.getBonusModule(self.$route.params.id).then(function (response) {
        self.data = response.data;
        TitleManager.setTitle(self.data.title)
        self.isLoading = false;
      })
        .catch(function () {
          self.$router.push({
            path: '/404'
          })
        })
    }
  }
</script>
<style>
  #lesson-bonus .subTitle {
    font-size: 16px;
    margin-bottom: 16px;
  }
</style>




// WEBPACK FOOTER //
// LessonBonus.vue?309af21a